import { Button } from "@aurem/ui";
import { useI18n } from "providers/I18nProvider";
import { useIntercom } from "providers/IntercomProvider";

export const ContactSupportLink = () => {
  const { t } = useI18n();
  const { show } = useIntercom();

  return (
    <div className="flex gap-1 justify-start">
      <span className="text-sm font-normal text-neutral-400">
        {t("apps.admin.common.needHelp")}
      </span>
      <Button variant="text" className="underline" onClick={show}>
        {t("apps.admin.common.contactSupport")}
      </Button>
    </div>
  );
};
